// @react/hooks/useWorkflowPipelinePolicy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { workflowPipelinePolicyStore } from '@core/stores';

/**
 * React hook for PipelinePolicy operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useWorkflowPipelinePolicy } from '@react/hooks';
 *
 * const PipelinePolicyList = observer(() => {
 *   const store = useWorkflowPipelinePolicy();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useWorkflowPipelinePolicy() {
  return workflowPipelinePolicyStore;
}
